var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Button } from 'reactstrap';
import { noop } from 'lodash';
import { ButtonSize, ButtonVariant, ButtonType } from './constants';
const TuxButton = forwardRef(function TuxButton(props, ref) {
    const { ariaLabel, block = false, children, className, disabled = false, size = ButtonSize.Default, type = ButtonType.Button, variant = ButtonVariant.Primary, onBlur = noop, onClick = noop, onKeyUp, onKeyDown } = props, rest = __rest(props, ["ariaLabel", "block", "children", "className", "disabled", "size", "type", "variant", "onBlur", "onClick", "onKeyUp", "onKeyDown"]);
    return (_jsx(Button, Object.assign({}, rest, { "aria-label": ariaLabel, block: block, className: className, color: variant, disabled: disabled, innerRef: ref, onBlur: onBlur, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size, type: type }, { children: children }), void 0));
});
export default TuxButton;
